import "./vendorprofile.scss";
import VendorProfileHeader from "../../../components/vendorprofileheader/VendorProfileHeader";
import {
  Vendor,
  selectedVendor,
  setSelectedVendor,
} from "../../../redux/vendor/vendorSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import Loading from "../../../components/LoadingPage/Loading";
import { useNavigate } from "react-router-dom";
import useVendors from "../../../Hooks/useVendors";
import useMckesson from "../../../Hooks/useMckesson";
import { useState, useEffect } from "react";
import { selectCurrentUserId } from "../../../redux/auth/authSlice";
import { toggleClass } from "../../../utils/commonUtils";
import { DeleteConfModel } from "../../../components/DeleteConfModel/deleteConfModel";
import { CommonDuplicateModel } from "../../../components/commonDuplicateModel/duplicateModel";
import { useModulePermissions, PermissionIdentifier, PermissionModule } from "../../../utils/permissionUtils";
import { Tab, Tabs } from "react-bootstrap";
import VendorSettingsView, { McKessonVendorDetail, McKessonShippingLocation, McKessonApiEntry } from "./VendorSettingsView";

const VendorProfile = () => {
  const selectedVendorData = useAppSelector(selectedVendor);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { activeVendorAPI, setVendorStatusActiveLoading } = useVendors();
  const { deactiveVendorAPI, setVendorStatusDeActiveLoading } = useVendors();
  const { deleteVendorAPI, deleteVendorLoading } = useVendors();
  const [showModal, setShowModal] = useState(false);
  const currentUserId = useAppSelector(selectCurrentUserId);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const { duplicateVendorAPI, duplicateVendorLoading } = useVendors();
  const { getMckessonVendorDetailAPI, getMckessonVendorDetailLoading } = useMckesson();
  const { getMckessonShippingLocationsAPI, getMckessonShippingLocationsLoading } = useMckesson();
  const { getMckessonApisAPI, getMckessonApisLoading } = useMckesson();
  const [mckessonVendorDetail, setMckessonVendorDetail] = useState<McKessonVendorDetail | null>(null);
  const [mckessonShippingLocations, setMckessonShippingLocations] = useState<McKessonShippingLocation[]>([]);
  const [mckessonApis, setMckessonApis] = useState<McKessonApiEntry[]>([]);

  useEffect(() => {
    if (selectedVendorData?.name?.toLowerCase() === "mckesson") {
      getMckessonVendorDetailAPI()
        .then((result: any) => {
          if (result && result.length > 0) {
            setMckessonVendorDetail(result[0]);
          }
        })
        .catch(() => { });
      getMckessonShippingLocationsAPI()
        .then((result: any) => {
          if (result) {
            setMckessonShippingLocations(result);
          }
        })
        .catch(() => { });
      getMckessonApisAPI()
        .then((result: any) => {
          if (result) {
            setMckessonApis(result);
          }
        })
        .catch(() => { });
    }
  }, []);

  const updateStatus = () => {
    if (selectedVendorData.isActive) {
      deactiveVendorAPI({
        id: selectedVendorData.id,
        updatedBy: currentUserId ?? "",
      })
        .then((res: Vendor) => {
          if (res) {
            dispatch(setSelectedVendor(res));
          }
        })
        .catch();
    } else {
      activeVendorAPI({
        id: selectedVendorData.id,
        updatedBy: currentUserId ?? "",
      })
        .then((res: Vendor) => {
          if (res) {
            dispatch(setSelectedVendor(res));
          }
        })
        .catch();
    }
  };

  const deleteVendor = async () => {
    await deleteVendorAPI({
      id: selectedVendorData.id,
      updatedBy: currentUserId ?? "",
    });
    toggleModal();
    navigate("/vendor-master");
  };

  const toggleModal = () => {
    toggleClass();
    setShowModal(!showModal);
  };

  const toggleDuplicateModal = () => {
    toggleClass();
    setShowDuplicateModal(!showDuplicateModal);
  };

  const duplicateVendor = async () => {
    await duplicateVendorAPI({
      id: selectedVendorData.id,
      updatedBy: currentUserId ?? "",
    });
    toggleDuplicateModal();
    navigate("/vendor-master");
  };

  const isPermitted = useModulePermissions(PermissionModule.VENDER_MASTER);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_VENDOR_MASTER);
  const isDuplicatePermitted = isPermitted(PermissionIdentifier.DUPLICATE_VENDOR_MASTER);

  const isMckesson = selectedVendorData?.name?.toLowerCase() === "mckesson";

  const vendorDetailsContent = (
    <div className="profile-detail-box">
      <div className="profile-info-box">
        <label>Name</label>
        <p>{selectedVendorData.name}</p>
      </div>
      <div className="profile-info-box">
        <label>Address 1</label>
        <p>{selectedVendorData.address || "-"}</p>
      </div>
      <div className="profile-info-box">
        <label>Address 2</label>
        <p>{selectedVendorData.address2 || "-"}</p>
      </div>
      <div className="profile-info-box">
        <label>City</label>
        <p>{selectedVendorData.city || "-"}</p>
      </div>
      <div className="profile-info-box">
        <label>State</label>
        <p>{selectedVendorData.state || "-"}</p>
      </div>
      <div className="profile-info-box">
        <label>Zip</label>
        <p>{selectedVendorData.zipCode || "-"}</p>
      </div>
      <div className="profile-info-box">
        <label>Email ID</label>
        <p>{selectedVendorData.email || "-"}</p>
      </div>
      <div className="profile-info-box">
        <label>Phone</label>
        <p>{selectedVendorData.phone || "-"}</p>
      </div>
      <div className="profile-info-box">
        <label>Contact Person</label>
        <p>{selectedVendorData.contactPerson || "-"}</p>
      </div>
      <div className="profile-info-box">
        <label>Status</label>
        <p> {selectedVendorData.isActive ? "Active" : "Inactive"}</p>
      </div>
    </div>
  );

  return (
    <div className="profile-page-wrapper">
      {(setVendorStatusActiveLoading ||
        setVendorStatusDeActiveLoading ||
        deleteVendorLoading ||
        duplicateVendorLoading ||
        getMckessonVendorDetailLoading ||
        getMckessonShippingLocationsLoading ||
        getMckessonApisLoading) && <Loading />}

      <VendorProfileHeader
        selectedVendorData={selectedVendorData}
        updateStatus={updateStatus}
        toggleModal={toggleModal}
        duplicateVendor={toggleDuplicateModal}
      />

      <div className="profile-detail-box-wrapper">
        <div className="vendor-profile-detail-box">
          {isMckesson ? (
            <Tabs defaultActiveKey="vendorDetails" id="vendor-profile-tabs" className="mb-3">
              <Tab eventKey="vendorDetails" title="Vendor Details">
                <div className="vendor-tab-content-wrapper">
                  {vendorDetailsContent}
                </div>
              </Tab>
              <Tab eventKey="vendorSettings" title="Vendor Settings">
                <div className="vendor-tab-content-wrapper">
                  <VendorSettingsView
                    vendorDetail={mckessonVendorDetail}
                    shippingLocations={mckessonShippingLocations}
                    apiEntries={mckessonApis}
                    isLoading={getMckessonVendorDetailLoading || getMckessonShippingLocationsLoading || getMckessonApisLoading}
                  />
                </div>
              </Tab>
            </Tabs>
          ) : (
            vendorDetailsContent
          )}
        </div>
      </div>

      <DeleteConfModel
        showModal={showModal}
        toggleModal={toggleModal}
        deleteAction={deleteVendor}
        recordName={selectedVendorData?.name || ""}
        modelName={`vendor`}
        isDeletePermitted={isDeletePermitted}
      />

      <CommonDuplicateModel
        showDuplicateModal={showDuplicateModal}
        toggleDuplicateModal={toggleDuplicateModal}
        modelName={`vendor`}
        recordName={selectedVendorData?.name ?? ""}
        duplicate={duplicateVendor}
        isDuplicatePermitted={isDuplicatePermitted}
      />
    </div>
  );
};

export default VendorProfile;
